if (!customElements.get('share-button')) {
  customElements.define('share-button', class ShareButton extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        shareButton: this.querySelector('button'),
        shareSummary: this.querySelector('summary'),
        mainDetailsToggle: this.querySelector('details'), // Details tag yahan pakda
        closeButton: this.querySelector('.share-button__close'),
        successMessage: this.querySelector('[id^="ShareMessage"]'),
        urlInput: this.querySelector('input'),
      };
      
      this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

      if (navigator.share) {
        // Agar native share available hai (jaisa aapne screenshot mein dikhaya)
        this.elements.mainDetailsToggle.setAttribute('hidden', '');
        this.elements.shareButton.classList.remove('hidden');
        this.elements.shareButton.addEventListener('click', () => {
          navigator.share({ url: this.urlToShare, title: document.title });
        });
      } else {
        // Fallback: Agar native menu support nahi hai (purane desktop browsers)
        this.elements.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
        this.querySelector('.share-button__copy').addEventListener('click', this.copyToClipboard.bind(this));
        
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.close.bind(this));
        }
      }
    }

    toggleDetails() {
      if (!this.elements.mainDetailsToggle.open) {
        this.elements.successMessage.classList.add('hidden');
        this.elements.successMessage.textContent = '';
        if (this.elements.closeButton) this.elements.closeButton.classList.add('hidden');
        this.elements.shareSummary.focus();
      }
    }

    copyToClipboard() {
      navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
        if (this.elements.successMessage) {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = 'Link Copied!';
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        }
      });
    }

    close() {
      this.elements.mainDetailsToggle.removeAttribute('open');
    }
  });
}
